import { AxiosError } from "axios";

let refresh: Promise<void> | undefined;

export const handlePolicyAccessDenied = (error: AxiosError): void => {
  const data = error.response?.data as { code?: string } | undefined;
  if (error.response?.status !== 403 || data?.code !== "policy_route_forbidden" || refresh) return;

  // Access may have expired since app-config was loaded. Coalesce simultaneous failures.
  refresh = import("../stores/appConfigStore")
    .then(({ default: store }) => store.onRefreshConfig())
    .catch(() => undefined)
    .finally(() => { refresh = undefined; });
};
